/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Report_PdfInputs */

const en_us2_coaching_report_pdf = /** @type {(inputs: Coaching_Report_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF report`)
};

const pt_br2_coaching_report_pdf = /** @type {(inputs: Coaching_Report_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relatório em PDF`)
};

const pt_pt2_coaching_report_pdf = /** @type {(inputs: Coaching_Report_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relatório em PDF`)
};

/** @type {(inputs: Coaching_Report_PdfInputs) => LocalizedString} */
const es_419_coaching_report_pdf = en_us2_coaching_report_pdf;

/** @type {(inputs: Coaching_Report_PdfInputs) => LocalizedString} */
const fr_fr2_coaching_report_pdf = en_us2_coaching_report_pdf;

/** @type {(inputs: Coaching_Report_PdfInputs) => LocalizedString} */
const de_de2_coaching_report_pdf = en_us2_coaching_report_pdf;

/** @type {(inputs: Coaching_Report_PdfInputs) => LocalizedString} */
const it_it2_coaching_report_pdf = en_us2_coaching_report_pdf;

/**
* | output |
* | --- |
* | "PDF report" |
*
* @param {Coaching_Report_PdfInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_report_pdf = /** @type {((inputs?: Coaching_Report_PdfInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Report_PdfInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_report_pdf(inputs)
	if (locale === "es-419") return es_419_coaching_report_pdf(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_report_pdf(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_report_pdf(inputs)
	if (locale === "de-DE") return de_de2_coaching_report_pdf(inputs)
	if (locale === "it-IT") return it_it2_coaching_report_pdf(inputs)
	return en_us2_coaching_report_pdf(inputs)
});
export { coaching_report_pdf as "coaching.report_pdf" }